// extracted by mini-css-extract-plugin
export default {"container":"pdf-download-panel_container__VukQU","image-wrapper":"pdf-download-panel_image-wrapper__d43Rz","image":"pdf-download-panel_image__A-pVh"};